export default __webpack_public_path__ + "0e5038e6920ff5747599fdbfa66f56fe.png";